import { Routes, Route } from "react-router-dom";
import MyRoute from "./MyRoute";
import LoginPage from "../pages/LoginPage";
import MainPage from "../pages/MainPage";
const AppRoutes = () => {
  return <Routes>
      <Route path="/login" element={<MyRoute element={<LoginPage />} isPublic={true} />} />
      <Route path="*" element={<MainPage />} />
    </Routes>;
};
export default AppRoutes;